function initSwiper() {
  new Swiper('.pod-header .swiper', {
    slidesPerView: 3,
    spaceBetween: 10,
    slideToClickedSlide: true,
    breakpoints: {
      1366: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
    },
    pagination: {
      el: '.pod-header .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.pod-header .swiper-button-next',
      prevEl: '.pod-header .swiper-button-prev',
    },
  });
}
initSwiper();

document.addEventListener('shopify:section:load', () => {
  initSwiper();
});

class RoomSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this._rooms = [
      'Living Room',
      'Dining Room',
      'Master Room',
      'Guest Room',
      'Kids Room'
    ];

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
          width: 100%;
        }
        .input-label {
          font-weight: 600;
          font-size: 13px;
          margin: 6px 0;
        }
        .roomlist-box {
          position: relative;
        }
        input {
          width: 100%;
          padding: 8px 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 13px;
          box-sizing: border-box;
        }
        .roomlist {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          max-height: 200px;
          margin: 4px 0 0;
          padding: 0;
          list-style: none;
          border: 1px solid #ccc;
          border-radius: 4px;
          background: white;
          z-index: 100;
          overflow-y: auto;
          display: none;
        }
        .roomlist.show {
          display: block;
        }
        .content-text {
          padding: 8px 10px;
          cursor: pointer;
          font-size: 13px;
        }
        .content-text:hover {
          background: #f2f2f2;
        }
      </style>
      <div class="input-label">Room Name</div>
      <div class="roomlist-box">
        <input type="text" placeholder="Optional" />
        <ul class="roomlist"></ul>
      </div>
    `;

    this.input = this.shadowRoot.querySelector('input');
    this.list = this.shadowRoot.querySelector('.roomlist');
  }

  connectedCallback() {
    this.renderList();

    this.input.addEventListener('focus', () => {
      this.list.classList.add('show');
      this.filterList(this.input.value);
    });

    this.input.addEventListener('input', () => {
      this.filterList(this.input.value);
    });

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.list.classList.remove('show');
        this.dispatchEvent(new CustomEvent('room-select', {
          detail: { value: this.input.value.trim() }
        }));
      }
    });

    this.list.addEventListener('click', (e) => {
      if (e.target.classList.contains('content-text')) {
        const val = e.target.textContent;
        this.input.value = val;
        this.list.classList.remove('show');
        this.dispatchEvent(new CustomEvent('room-select', {
          detail: { value: val }
        }));
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && !this.shadowRoot.contains(e.target)) {
        this.list.classList.remove('show');
      }
    });
  }

  renderList(filter = '') {
    this.list.innerHTML = '';
    const lower = filter.toLowerCase();
    let matched = false;
  
    this._rooms.forEach(room => {
      if (room.toLowerCase().includes(lower)) {
        matched = true;
        const li = document.createElement('li');
        li.className = 'content-text';
        li.textContent = room;
        this.list.appendChild(li);
      }
    });

    this.list.classList.add('show');
  }

  filterList(val) {
    this.renderList(val.trim());
  }

  get value() {
    return this.input.value.trim();
  }

  set value(val) {
    this.input.value = val;
  }

  get options() {
    return this._rooms.slice();
  }

  set options(val) {
    if (Array.isArray(val)) {
      this._rooms = val;
      this.renderList(this.input.value);
    }
  }

  addRoom(val) {
    const trimmed = val.trim();
    if (trimmed && !this._rooms.includes(trimmed)) {
      this._rooms.push(trimmed);
      this.renderList(trimmed);
    }
  }
}

customElements.define('room-select', RoomSelect);

class PodEditor extends HTMLElement {
	constructor() {
		super();
    this.totalStep = this.dataset.totalStep;
    this.storeUtil = new StorageUtil('pod_');
    this.placeholder = this.dataset.placeholder;
    this.pageStep = 1;
    this.customWidthNames = this.dataset.customWidthNames.split(',');
    this.customHeightNames = this.dataset.customHeightNames.split(',');
    this.baseMap = {
      "1.5x Fullness": 1.5,
      "2.0x Fullness": 2,
      "2.5x Fullness": 2.5,
      // Panel
      "Single Panel": 1,
      "Split Panel": 0.5,
      // 
      "1/2” Above Floor": -0.5,
      "Kiss Floor": 0,
      "2” Puddle": 2,
    }
    this.defaultConfig = {     
      panel: 'Split Panel',
      fullness: '2.0x Fullness',
      finished_length: 'Kiss Floor'
    }
	}

	connectedCallback() {
    this.loadConfig();
    this.limitInput();
		this.bindEvents();
    this.watchWindowResize();
    this.initRoom();
	}

  initRoom() {
    Array.from(this.querySelectorAll('.room-box')).forEach(roomBox => {
      roomBox.addEventListener('room-select', (e) => {
        // 添加新项（如果需要）
        if (!roomBox.options.includes(e.detail.value)) {
          roomBox.addRoom(e.detail.value);
        }
      });
      // 动态设置房间列表
      roomBox.options = [
        'Living Room',
        'Dining Room',
        'Master Room',
        'Guest Room',
        'Kids Room'
      ];
      // 设置当前值
      roomBox.value = this.config.room || '';
    })
  }

  updateSummaryCoverSize() {
    const sumaryNode = this.querySelector('.pod-mb .pod-summary');
    const bgHeight = sumaryNode.querySelector('.pod-image__bg').clientHeight;
    const coverHeight = parseInt(bgHeight / 6 * 5);
    sumaryNode.querySelector('.pod-image__cover').setAttribute('style', `height: ${coverHeight}px;`)
  }
  watchWindowResize() {
    window.addEventListener('resize', () => {
      updateSummaryCoverSize();
    });
  }
  get currentStep() {
  	return parseInt(this.getAttribute('data-step'));
  }

  set currentStep(step) {
    step = parseInt(step);
    this.setAttribute('data-step', step);
    this.maxActiveStep = Math.max(step, this.maxActiveStep);

    const valueNode = this.querySelector(`.pod-step--active[data-step="${step}"] [data-value]`);
    if (valueNode && valueNode.dataset.value && step <= this.maxActiveStep) {
      this.querySelector('.progress-action__next').classList.add('progress-action--active');
    } else {
      this.querySelector('.progress-action__next').classList.remove('progress-action--active');
    }
  }

  get maxActiveStep() {
    return parseInt(this.getAttribute('data-max-active-step'));
  }

  set maxActiveStep(value) {
    this.setAttribute('data-max-active-step', value);
  }

  get pageStep() {
    return parseInt(this.getAttribute('data-page-step'));
  }

  set pageStep(value) {
    value = parseInt(value);
    this.setAttribute('data-page-step', value);
    if (value > 1) {
      this.querySelector('.progress-action__pre').classList.add('progress-action--active');
    } else {
      this.querySelector('.progress-action__pre').classList.remove('progress-action--active');
    }
  }

  updateConfigValues(type, config) {
    // update pod content
    Array.from(this.querySelectorAll(`.pod-content[data-type="${type}"]`)).forEach(item => {
      Array.from(item.querySelectorAll('input')).forEach(input => {
        input.value = config[type];
      })
      Array.from(item.querySelectorAll('.next-button')).forEach(button => {
        button.setAttribute('data-value', config[type]);
      })
      Array.from(item.querySelectorAll(`.option-item[data-option="${config[type]}"]`)).forEach(optionNode => {
        optionNode.classList.add('option-item--active');
      })
      Array.from(item.querySelectorAll(`.option-item[data-value="${config[type]}"]`)).forEach(optionNode => {
        optionNode.classList.add('option-item--active');
      })
      Array.from(item.querySelectorAll(`.header-slide[data-value="${config[type]}"]`)).forEach(slideNode => {
        slideNode.classList.add('header-slide--active');
      })
    })

    if (type == 'header') {
      const valueNode = this.querySelector(`.header-slide[data-value="${config[type]}"]`);
      const supportFullness = JSON.parse(valueNode.dataset.fullness.toLowerCase() || '[]');
      const fullnessValue = config.fullness.toLowerCase();
      Array.from(this.querySelectorAll('.pod-content[data-type="fullness"] .option-item')).forEach(item => {
        if (supportFullness.indexOf(item.dataset.option.toLowerCase()) <= -1) {
          item.classList.add('option-item--hidden');
        } else {
          item.classList.remove('option-item--hidden');
        }
      })
      if (supportFullness.indexOf(fullnessValue) <= -1) {
        this.querySelector('.pod-content[data-type="fullness"] .option-item:not(.option-item--hidden)').click();
      }
    }
  }

  loadConfig(force = false) {
    const config = Object.assign({}, this.defaultConfig, force ? {} : (this.storeUtil.get('config') || {}));
    this.config = config;
    
    const items = Array.from(this.querySelectorAll('.progress-item'));

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const type = item.dataset.type;
      if (config[type]) {
        item.querySelector('.progress-item__value').textContent = config[type];
        item.classList.add('pod-step--active');
        this.currentStep = parseInt(item.dataset.step);
      } else {
        break;
      }
    }

    Object.keys(config).forEach(type => {
      if (type != 'header') {
        this.updateConfigValues(type, config);
      }
    })
    if (config.header) {
      this.updateConfigValues('header', config);
    }

    this.updateImages();
  }

  updateSummary() {
    const progressData = this.getProgressData();
    Array.from(this.querySelectorAll('.pod-summary__container-right')).forEach(summaryNode => {
    	summaryNode.innerHTML = '';
      let innerHTML = '';
      Object.keys(progressData).concat(['Size per panel']).forEach(key => {
        if (key == 'Coverage Height' || key == 'Coverage Width') return;
        let itemValue = progressData[key];
        if (key == 'Size per panel') {
          itemValue = `${this.getWidth(progressData)}”W x ${this.getHeight(progressData)}”L`;
        }
      	innerHTML += `
        <div class="pod-summary__item">
      		<div class="pod-summary__item__title">${key}</div>
      		<div class="pod-summary__item__value">${itemValue}</div>
        </div>
      	`;
      })
      summaryNode.innerHTML = innerHTML;
    })
  }

  getWidth(progressData) {
    const pannelBase = this.baseMap[progressData['Panel']];
    const fullNessBase = this.baseMap[progressData['Fullness']] || 1;
    return (progressData['Coverage Width'] * pannelBase * fullNessBase).toFixed(1);
  }

  getHeight(progressData) {
    const finishedBase = this.baseMap[progressData['Finished Length']];
    return parseInt(progressData['Coverage Height']) + finishedBase;
  }

  validateInput(inputElement) {
    let value = inputElement.value;
    // 移除非数字字符
    value = value.replace(/[^0-9]/g, '');
    // 如果以 0 开头，移除第一个字符
    if (value.startsWith('0')) {
      value = value.substring(1);
    }
    // 更新输入框值
    inputElement.value = value;
  }

  limitInput() {
  	Array.from(this.querySelectorAll('input[type="text"]')).forEach(input => {
      input.addEventListener('input', () => {
        this.validateInput(input);
        var typeNode = input.closest('[data-type]');
        if (typeNode && typeNode.querySelector('.next-button')) {
          typeNode.querySelector('.next-button').setAttribute('data-value', input.value);
        }
      })
    });
  }

  toNextStep() {
    this.updateImages();
  	if (this.currentStep < this.totalStep) {
      Array.from(this.querySelectorAll(`[data-step="${this.currentStep}"]`)).forEach(item => {
      	if (item.classList.contains('pod-content')) {
      		item.classList.remove('pod-step--active');
        } else if (item.classList.contains('progress-item')) {
          item.classList.add('pod-step--active');
        }
      })
      Array.from(this.querySelectorAll(`[data-step="${this.currentStep+1}"]`)).forEach(item => {
        if (item.classList.contains('pod-content')) {
      		item.classList.add('pod-step--active');
        }
      })
    }
    // mb scroll left change
    Array.from(this.querySelectorAll(`.pod-mb .progress-item[data-step="${this.currentStep + 1}"]`)).forEach(item => {
      item.parentNode.scrollLeft = item.offsetLeft - 10;
    })
    setTimeout(() => {
    	this.updateSummaryCoverSize();
    }, 1500)

    this.pageStep = this.currentStep + 1;
  }


  updateImages() {
    const pcSelected = this.getSelectedImageKeys('.pod-pc');

    // update step images, pc / mb
    Array.from(this.querySelectorAll('.pod-pc .pod-content')).forEach(item => {
      let replaceValue = 'placeholder.svg', replaceValueDefault = 'placeholder.svg';
      if (item.dataset.type == 'header') return;
    	if (item.dataset.type == 'width') {
        replaceValue = this.customWidthNames.indexOf(pcSelected['header']) > -1 ?  `${pcSelected['header']}_width.png` : 'default_width.png';
      } else if (item.dataset.type == 'height') {
        replaceValue = this.customHeightNames.indexOf(pcSelected['header']) > -1 ?  `${pcSelected['header']}_height.png` : 'default_height.png';
      } else {
      	replaceValue = [pcSelected.header, pcSelected.panel, pcSelected.fullness, pcSelected.finished_length].join('_') + '.png';
      }
      var coverImageNode = item.querySelector('.pod-image__cover img');
      if (coverImageNode) {
        coverImageNode.src = this.placeholder.replace('___', replaceValue);
        coverImageNode.alt = replaceValue;
      }
    })
    Array.from(this.querySelectorAll('.pod-mb .pod-content')).forEach(item => {
      const typeValue = item.dataset.type;
    	let replaceValue = 'placeholder.svg', replaceValueDefault = 'placeholder.svg';
      if (typeValue == 'header') return;
      if (['width', 'height', 'summary'].indexOf(typeValue) <= -1) {
        Array.from(item.querySelectorAll('.option-item')).forEach(optionItemNode => {
          const newItemSelected = Object.assign({}, pcSelected);
          newItemSelected[typeValue] = optionItemNode.dataset.imageKey;
          replaceValue = [newItemSelected.header, newItemSelected.panel, newItemSelected.fullness, newItemSelected.finished_length].join('_') + '.png';
          var coverImageNode = optionItemNode.querySelector('.pod-image__cover img');
          if (coverImageNode) {
            coverImageNode.src = this.placeholder.replace('___', replaceValue);
            coverImageNode.alt = replaceValue;
          }
        })
      } else {
        if (typeValue == 'width') {
          replaceValue = pcSelected['header'] == 'ripple_fold' ? 'ripple_fold_width.png' : 'default_width.png';
        } else if (typeValue == 'height') {
          replaceValue = pcSelected['header'] == 'ripple_fold' ? 'ripple_fold_height.png' : 'default_height.png';
        } else if (typeValue == 'summary') {
          replaceValue = [pcSelected.header, pcSelected.panel, pcSelected.fullness, pcSelected.finished_length].join('_') + '.png';
        }
        var coverImageNode = item.querySelector('.pod-image__cover img');
        if (coverImageNode) {
          coverImageNode.src = this.placeholder.replace('___', replaceValue);
          coverImageNode.alt = replaceValue;
        }
      }
    })
  }

  getProgressData() {
  	const data = {};
  	Array.from(this.querySelectorAll('.progress-item')).forEach(item => {
  		const title = item.querySelector('.progress-item__title').dataset.title;
  		const value = item.querySelector('.progress-item__value').dataset.value;
  		data[title] = value;
  	})
  	return data;
  }

  getSummaryData() {
  	const data = {};
  	Array.from(this.querySelectorAll('.pod-pc .progress-item')).forEach(progressNode => {
  		const type = progressNode.dataset.type;
      const value = progressNode.querySelector('.progress-item__value').dataset.value || '';
  		data[type] = value;
  	})
    data.room = this.querySelector('.pod-pc .room-box').value || '';
  	return data;
  }

  getSelectedImageKeys(className) {
  	const data = {};
  	Array.from(this.querySelectorAll(`${className} [data-image-key]`)).forEach(item => {
      if (item.className.indexOf('active') <= -1) return;
  		const type = item.closest('[data-type]')?.dataset.type;
      if (!type) return;
  		const value = item.dataset.imageKey;
      if (!value) return;
  		data[type] = value;
  	})
  	return data;
  }

  bindEvents() {
    // progress click
  	Array.from(this.querySelectorAll('.progress-item')).forEach(editorProgress => {
  		editorProgress.addEventListener('click', (e) => {
  			e.preventDefault();
        let progressItem = null;
        if (e.target.classList.contains('progress-item')) {
          progressItem = e.target;
        } else {
          progressItem = e.target.closest('.progress-item');
        }
        if (!progressItem) return;
  			Array.from(document.querySelectorAll('.pod-content')).forEach(item => {
  				if (item.dataset.step === progressItem.dataset.step) {
  					item.classList.add('pod-step--active');
  				} else {
  					item.classList.remove('pod-step--active');
  				}
  			})
        this.currentStep = parseInt(progressItem.dataset.step);
          this.pageStep = this.currentStep;
  		})
  	})

    // option selected
    Array.from(this.querySelectorAll('.option-item')).forEach(optionNode => {
    	optionNode.addEventListener('click', (e) => {
    		e.preventDefault();

    		const optionNode = e.target.classList.contains('option-item')? e.target : e.target.closest('.option-item');
    		if (!optionNode) return;

        const optionValue = optionNode.querySelector('.option-item__title').dataset?.xvalue || '';

        const dataTypeNode = optionNode.closest('[data-type]');
        if (!dataTypeNode) return;

        const type = dataTypeNode.dataset.type;

        Array.from(this.querySelectorAll(`[data-type="${type}"]`)).forEach(typeNode => {
          typeNode.querySelector('.option-item--active')?.classList.remove('option-item--active');
          typeNode.querySelector(`.option-item[data-option="${optionValue}"]`)?.classList.add('option-item--active');
          typeNode.querySelector('.next-button')?.setAttribute('data-value', optionValue);
        })

        this.updateImages();
    	})
    })

    // value click
    Array.from(this.querySelectorAll('[data-value]')).forEach(valueNode => {
    	valueNode.addEventListener('click', (e) => {
    		e.preventDefault();
        const valueNode = e.target.hasAttribute('data-value') ? e.target : e.target.closest('[data-value]');
    		const value = valueNode.dataset.value;
        if (!value) return;

        const typeNode = e.target.closest('[data-type]');
        if (!typeNode) return;
        const valueType = typeNode.dataset.type;

        if (valueType == 'header') {
          const supportFullness = JSON.parse(valueNode.dataset.fullness.toLowerCase() || '[]');
          Array.from(this.querySelectorAll('.pod-content[data-type="fullness"] .option-item')).forEach(item => {
            if (supportFullness.indexOf(item.dataset.option.toLowerCase()) <= -1) {
              item.classList.add('option-item--hidden');
            } else {
              item.classList.remove('option-item--hidden');
            }
          })
          Array.from(this.querySelectorAll('.pod-content[data-type="fullness"')).forEach(item => {
            const optionNode = item.querySelector('.option-item:not(.option-item--hidden)')
            if (optionNode) {
              optionNode.click();
            }
          })
        } else if (valueType == 'width' || valueType == 'height') {
        	if (parseInt(value) < 12) {
            Array.from(this.querySelectorAll(`.pod-content[data-type="${valueType}"] .input-error`)).forEach(errorNode => {
              errorNode.setAttribute('style', 'display: block;');
            })
            return;
          } else {
            Array.from(this.querySelectorAll(`.pod-content[data-type="${valueType}"] .input-error`)).forEach(errorNode => {
              errorNode.setAttribute('style', 'display: none;');
            })
          }
        }

        Array.from(this.querySelectorAll(`.pod-content[data-type="${valueType}"]`)).forEach(typeNode => {
          if (typeNode.querySelector('.header-slide')) {
            typeNode.querySelector('.header-slide--active')?.classList.remove('header-slide--active');
            typeNode.querySelector(`.header-slide[data-value="${value}"]`)?.classList.add('header-slide--active');
          }
          if (typeNode.querySelector('.option-item')) {
            typeNode.querySelector('.option-item--active')?.classList.remove('option-item--active');
            typeNode.querySelector(`.option-item[data-option="${value}"]`)?.classList.add('option-item--active');
            typeNode.querySelector(`.option-item[data-value="${value}"]`)?.classList.add('option-item--active');
          }
        })

        Array.from(this.querySelectorAll(`.progress-item[data-type="${valueType}"]`)).forEach(item => {
          item.querySelector('.progress-item__value').textContent = value;
          item.querySelector('.progress-item__value').dataset.value = value;
          item.classList.add('pod-step--active');
          this.currentStep = parseInt(item.dataset.step);
          this.toNextStep();
        })

        this.updateSummary();
    	})
    })

    // shop now click
    Array.from(this.querySelectorAll('.pod-shop')).forEach(shopNode => {
    	shopNode.addEventListener('click', (e) => {
    		e.preventDefault();
        this.storeUtil.set('config', this.getSummaryData());
        window.location.href = Shopify.routes.root + 'collections';
    	})
    })

    // reset click
    Array.from(this.querySelectorAll('.pod-reset')).forEach(resetNode => {
    	resetNode.addEventListener('click', () => {
    		this.podReset();
    	})
    })

    Array.from(this.querySelectorAll('.progress-action__btn')).forEach(btn => {
    	btn.addEventListener('click', () => {
        
        if (btn.classList.contains('progress-action__next') &&  btn.classList.contains('progress-action--active')) {
          const valueNode = this.querySelector(`.pod-step--active[data-step="${this.currentStep}"] [data-value]`);
          if (valueNode && valueNode.dataset.value) {
            valueNode.click();
          }
        }
        if (btn.classList.contains('progress-action__pre') &&  btn.classList.contains('progress-action--active')) {
          var preNode = this.querySelector(`.progress-item.pod-step--active[data-step="${this.pageStep - 1}"]`)
          if (preNode) {
            preNode.click()
          } else {
            this.querySelector(`.progress-item.pod-step--active[data-step="${this.currentStep}"]`)?.click()
          }
        }
    	})
    })
  }

  podReset() {
    this.storeUtil.remove('config');
    Array.from(this.querySelectorAll('.pod-step--active')).forEach(item => {
      item.classList.remove('pod-step--active');
    })
    Array.from(this.querySelectorAll('.progress-item__value')).forEach(item => {
      item.textContent = '';
    })
    Array.from(this.querySelectorAll('.pod-content[data-type="header"]')).forEach(item => {
      item.classList.add('pod-step--active');
    })
    Array.from(this.querySelectorAll('.header-slide--active')).forEach(item => {
      item.classList.remove('header-slide--active');
    })
    Array.from(this.querySelectorAll('.pod-content')).forEach(content => {
      Array.from(content.querySelectorAll('input')).forEach(input => {
        input.value = this.defaultConfig[input.name] || '';
      })
      Array.from(content.querySelectorAll('.next-button')).forEach(button => {
        button.setAttribute('data-value', '');
      })
      Array.from(content.querySelectorAll('.option-item--active')).forEach(item => {
        item.classList.remove('option-item--active');
      })
    })
    this.loadConfig(true);
    this.pageStep = 1;
    this.currentStep = 1;
    this.maxActiveStep = 1;
    Array.from(this.querySelectorAll('.progress-action--active')).forEach(item => {
      item.classList.remove('progress-action--active');
    })
  }
}
if (!customElements.get('pod-editor')) {
	customElements.define('pod-editor', PodEditor);
}